import React from 'react';
import { IFilteredOrganization } from '../../../../../api/attendees.dao';
import Text from '../../../../global/text/text';
import { Attendee } from './_attendee/_attendee';
import { IAttendeesListProps } from './_attendees-list';

interface IProps extends IAttendeesListProps, IFilteredOrganization {}

const Organization = (props: IProps) => {
    const {
    	name,
        attendees = [],
        organizationId,
        markedOrganization,
        orgIdToConnectionParticipantsNameMap,
        orgIdToConnectionPresentersNameMap,
        orgIdToConnectionHostsNameMap,
        orgIdToConnectionSupportsNameMap,
        selectedAttendeeFilter,
        withTableView,
        isAttendeeListSortedByFirstName,
        ...otherProps
    } = props;

    const getConnections = () => {
        switch (props.roleKey) {
            case 'selectedParticipants':
                return <Text message={orgIdToConnectionParticipantsNameMap[organizationId]} withEllipsis/>;
            case 'selectedPresenters':
                return <Text message={orgIdToConnectionPresentersNameMap[organizationId]} withEllipsis/>;
            case 'selectedHosts':
                return <Text message={orgIdToConnectionHostsNameMap[organizationId]} withEllipsis/>;
            case 'selectedSupports':
                return <Text message={orgIdToConnectionSupportsNameMap[organizationId]} withEllipsis/>;
            default:
                break;
        }
    };

    return (
        <div>
            {!selectedAttendeeFilter ? <div className='attendees-list-header'>
                <div className='attendees-list-header-name-container overflow-ellipsis'>
                    <label title={name}>{markedOrganization ?? name}</label>
                </div>
                {withTableView && (
                    <div className='attendees-list-header-connection'>
                        {attendees.length === 0 && getConnections()}
                    </div>
                )}
            </div> : null}
            {attendees.length ?
                attendees
                    .slice()
                    .sort((a, b) => {
                        if (!isAttendeeListSortedByFirstName) {
                            return a.lastName.localeCompare(b.lastName);
                        } else {
                            return a.firstName.localeCompare(b.firstName);
                        }
                    })
                    .map(attendee => {
                        return (
                            <Attendee
                                key={attendee.attendeeId}
                                organizationId={organizationId}
                                selectedAttendeeFilter={selectedAttendeeFilter}
                                withTableView={withTableView}
                                {...attendee}
                                {...otherProps}
                            />
                        );
                    }) : null}
        </div>
    );
};

export { Organization };
